import React, { useState, useEffect, useRef } from 'react';
import { fetchUserProfile } from '../../../services/userService';
import { userSubscriptions } from '../../../services/subcriptionsService';
import Spinner from "../../../utils/Spinner"; // Import the Spinner component
import "../../../css/userprofile.css";
import JobBox from './sections/JobBox';
import { getPublicUserJobs } from '../../../services/jobsService';
import { getImage } from '../../../utils/cloudinarySizing';

const PublicProfilePage = ({ id }) => {
    const [profileData, setProfileData] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [brokenAvatar, setBrokenAvatar] = useState(false);

    const [isOverlayOpen, setOverlayOpen] = useState(false);

    const avatarSrc =
        !brokenAvatar && profileData?.photo_original
            ? getImage(profileData.photo_original, "avatar_sm")
            : "/servspace-default-150x150.png";

    const overlaySrc =
        !brokenAvatar && profileData?.photo_original
            ? getImage(profileData.photo_original, "avatar_lg")
            : "/servspace-default-500x500.png";

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [
                    profileResponse,
                    jobsResponse
                ] = await Promise.all([
                    fetchUserProfile(id),
                    getPublicUserJobs(id)
                ]);

                setProfileData({
                    photo_original: profileResponse.profile?.photo_original || "/servspace-default-500x500.png",
                    first_name: profileResponse.profile?.first_name,
                    bio: profileResponse.bio || ""
                });

                setJobs(jobsResponse);

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [id]);


    if (loading) return <Spinner />;

    return (
        <div className="page-wrapper">
            <div className="profile-container">
                <div className='centered-content'>
                    <div className="profile-content">

                        {/* LEFT SIDE */}
                        <div className="left-side">
                            <div className='photo-and-reviews'>
                                <div className="profile-photo">
                                    <img
                                        onClick={() => setOverlayOpen(true)}
                                        src={avatarSrc}
                                        alt="profile"
                                        onError={() => setBrokenAvatar(true)}
                                    />
                                </div>

                                {isOverlayOpen && (
                                    <div className="image-overlay" onClick={() => setOverlayOpen(false)}>
                                        <img src={overlaySrc} alt="profile-large" />
                                    </div>
                                )}
                            </div>

                            <div className="user-profile-user-info">
                                <h3>{profileData.first_name}</h3>
                                <p>{profileData.bio}</p>
                            </div>
                        </div>

                        {/* RIGHT SIDE (cover) */}
                        <div className="right-side" style={{ backgroundImage: `url(${profileData.cover_image})` }} />

                    </div>

                    <div className="container">
                        <JobBox jobs={jobs} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicProfilePage;